<template>
    <div class="t-work-area__row">
        <div class="t-work-area__column_small _min">
            <div class="t-work-area__cell">
                <div class="t-avatar">
                    <img v-if="user.img !== '' && !editImage" class="t-avatar__img" :src="user.img" >
                    <img v-else-if="!editImage" class="t-avatar__img" src="/img/default_img.png">
                    <div v-else class="t-avatar__img t-avatar__img-edit" > 
                        <v-image-input
                            v-model="imageData"
                            image-format="jpeg"
                            :hideActions="true" 
                            :fullHeight="true"
                            :fullWidth="true"
                            overlayPadding="10px"
                        />
                    </div>
                    <span class="t-avatar__info">{{ pageTextInfo.infoImg }}</span>

                    <!-- <button v-if="!editImage" class="t-btn t-btn_full t-btn_file" @click.stop.prevent="EditImage()" type="button"
                            ><span>{{ pageTextInfo.uploadImg }}</span></button> -->
                    
                    <label v-if="!editImage" class="t-btn t-btn_full t-btn_file">
                        <input type="file" @change="EditImage($event.target.files)"><span>{{ pageTextInfo.uploadImg }}</span>
                    </label>

                    <button v-else class="t-btn t-btn_full t-btn_file" @click.stop.prevent="SaveImage()" type="button"
                            ><span>{{ pageTextInfo.saveImg }}</span></button>

                    <!-- <label class="t-btn t-btn_full t-btn_file">
                        <input type="file" @change="LoadFile($event.target.files)"><span>{{ pageTextInfo.uploadImg }}</span>
                    </label> -->
                    <!-- <button class="t-btn t-btn_full t-btn_file" :class="{'t-btn_white': editImage}" @click="SetImg" type="button">
                        <span>{{ pageTextInfo.uploadImg }}</span>
                    </button> -->
                    <!-- <button v-if="editImage" class="t-btn t-btn_full t-btn_file" @click="SaveImg" type="button" >
                        <span>{{ pageTextInfo.saveImg }}</span>
                    </button> -->
                    <button class="t-btn t-btn_full t-btn_white" @click.stop.prevent="DelAvatar()"
                            v-if="user.img !== ''"><span>{{ pageTextInfo.deleteImg }}</span></button>
                </div>
            </div>
        </div>
        <div class="t-work-area__column_big t-profile">
            <div class="t-work-area__cell">
                <h2>{{ pageTextInfo.title_1 }}</h2>
                <div class="t-inputBox" v-if="!editInfo">
                    <div class="t-input">
                        <label>{{ pageTextInfo.fio }}</label>
                        <p>{{ fullName }}</p>
                    </div>
                    <div class="t-input">
                        <label>{{ pageTextInfo.birdthDay }}</label>
                        <p>{{ birth_day }}</p>
                    </div>
                    <div class="t-input">
                        <label>{{ pageTextInfo.location }}</label>
                        <p>{{ user.location }}</p>
                    </div>
                    <div class="t-input">
                        <label>{{ pageTextInfo.timeZone }}</label>
                        <p>{{ time_zone }}</p>
                    </div>
                    <div class="t-input">
                        <label>{{ pageTextInfo.language }}</label>
                        <p>{{ language }}</p>
                    </div>
                    <!-- <div class="t-input">
                        <label>{{ pageTextInfo.knowledge }}</label>
                        <p>{{ field_knowledge }}</p>
                    </div> -->
                    <div class="t-input">
                        <label>{{ pageTextInfo.topics }}</label>
                        <p>{{ interesting_topics }}</p>
                    </div>
                    <div class="t-input t-input__styled">
                        <label>{{ pageTextInfo.about }}</label>
                        <p v-html="about"></p>
                    </div>
                    <div class="t-input t-input__styled">
                        <label>{{ pageTextInfo.education }}</label>
                        <p v-html="education"></p>
                    </div>
                    <div class="t-input t-input__styled">
                        <label>{{ pageTextInfo.experience }}</label>
                        <p v-html="experience"></p>
                    </div>
                </div>
                <div class="t-inputBox" v-else>
                    <div class="t-input "
                         :class="[item.class, {_error: item.error, 't-input_30': item.type !== 'textarea'}]"
                         v-for="(item, index) in form_info"
                         :key="index">
                        <label>{{ item.title }}
                            <span v-if="user.isTeacher && item.required && (item.value == '' || item.value == [] || item.value == null ) "
                                    class="t-must">
                                {{pageTextInfo.must}}
                            </span>
                        </label>

                        <textarea-autosize v-if="item.type === 'textarea'" v-model="item.value"
                                           :min-height="80"></textarea-autosize>

                        <input v-if="item.type === 'text'" v-model="item.value">

                        <date-picker v-if="item.type === 'date'"
                                     v-model="item.value"
                                     :first-day-of-week="1"
                                     lang="ru"
                                     format="DD.MM.YYYY"
                                     :clearable="false" width="100%"></date-picker>

                        <v-select v-if="item.type === 'select' && item.name === 'location'"
                                v-model="item.value"
                                :options="item.options"
                                :searchable="item.searchable"
                                :filterable="false"
                                @search="yandexSearch(index, $event)"
                                @input="yandexSearch(index, $event)">
                            <template #no-options="{ search, searching, loading }">
                                {{ pageTextInfo.locationNoOptions }}
                            </template>
                        </v-select>

                        <v-select v-if="item.type === 'select' && item.name !== 'location'"
                                  v-model="item.value"
                                  :options="item.options"
                                  :searchable="true"
                                  :filterable="true"></v-select>

                        <cmp-multi-select v-if="item.type === 'select_multi'"
                                          :value="item.value"
                                          :options="item.options"
                                          :name="item.name"
                                          @updateSelect="updateSelect(index, $event)"
                        ></cmp-multi-select>

                        <cmp-topics-select v-if="item.type === 'topics_select'"
                                        :value="item.value"
                                        :options="item.options"
                                        :name="item.name"
                                        v-model="item.value"
                                        class="_right"
                        ></cmp-topics-select>
                    </div>
                </div>
                <div class="t-input_buttons">
                    <button class="t-btn" v-if="!editInfo" @click.stop.prevent="editInfo = true">
                        <span>{{ pageTextInfo.updateBtn }}</span>
                    </button>
                    <template v-else>
                        <button class="t-btn" 
                                :disabled="user.isTeacher && !canSave"
                                @click.stop.prevent="SaveInfo()"><span>{{ pageTextInfo.saveBtn }}</span>
                        </button>
                        <button class="t-btn t-btn_white" @click.stop.prevent="CancelInfo"><span>{{ pageTextInfo.cancelBtn }}</span>
                        </button>
                    </template>
                </div>

                <h2>{{ pageTextInfo.video }}</h2>
                <div class="t-profile__video" v-if="form_video.type === 'youtube'">
                    <iframe width="272" height="152"
                            :src="'https://www.youtube.com/embed/' + form_video.link + '?rel=0&amp;controls=1&amp;showinfo=0'"
                            frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
                <div class="t-profile__video" v-if="form_video.type === 'vimeo'">
                    <iframe :src="'https://player.vimeo.com/video/' + form_video.link + ''" width="272" height="152"
                            frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                </div>
                <div class="t-input t-input_30" v-if="editVideo" :class="{_error: form_video.error}">
                    <label>{{ pageTextInfo.formVideoTitle }}</label>
                    <input v-model="form_video.value" :placeholder="form_video.placeholder">
                    <span class="t-input_hint" v-if="form_video.error">{{ form_video.error_text }}</span>
                </div>
                <div class="t-input_buttons">
                    <template v-if="!editVideo">
                        <button class="t-btn" v-if="form_video.type != ''" @click.stop.prevent="editVideo = true"><span>{{ pageTextInfo.updateBtn }}</span>
                        </button>
                        <button class="t-btn" v-else @click.stop.prevent="editVideo = true"><span>{{ pageTextInfo.uploadBtn }}</span>
                        </button>
                    </template>
                    <template v-else>
                        <button class="t-btn" @click.stop.prevent="SaveVideo"><span>{{ pageTextInfo.saveBtn }}</span>
                        </button>
                        <button class="t-btn t-btn_white" @click.stop.prevent="CancelVideo"><span>{{ pageTextInfo.cancelBtn }}</span>
                        </button>
                    </template>
                </div>

                <h2>{{ pageTextInfo.contacts }}</h2>
                <div class="t-inputBox t-inputBox_start" v-if="!editContacts">
                    <div class="t-input t-input_auto" v-for="(contact, index) in form_contacts">
                        <label>{{ contact.title }}</label>
                        <p class="t-profile__contacts">
                            {{ contact.value }}
                            <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                 xmlns="http://www.w3.org/2000/svg" v-if="contact.main">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M2 2V11.22L3.74603 9.55893C4.34081 8.9931 5.12899 8.63474 6 8.63474C6.871 8.63474 7.65919 8.9931 8.25397 9.55893L10 11.22V2H2ZM9.9662 12.2101C9.96605 12.21 9.96707 12.2079 9.96972 12.2042C9.96767 12.2083 9.96635 12.2102 9.9662 12.2101ZM2.0338 12.2101C2.03365 12.2102 2.03232 12.2083 2.03028 12.2042C2.03293 12.2079 2.03395 12.21 2.0338 12.2101ZM10.5 0C11.3284 0 12 0.888889 12 1.98539V12.0111C12 13.6286 10.6169 14.5673 9.62455 13.6233L6.87545 11.008C6.35237 10.5103 5.64763 10.5103 5.12455 11.008L2.37545 13.6233C1.3831 14.5673 0 13.6286 0 12.0111V1.98539C0 0.888889 0.671573 0 1.5 0H10.5Z"
                                      fill="#B8D7F5"/>
                            </svg>
                            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                 xmlns="http://www.w3.org/2000/svg" v-if="contact.admin">
                                <path
                                        d="M0.379518 12C0.283133 12 0.192771 11.9657 0.108434 11.8971C0.0361446 11.8286 0 11.7429 0 11.64L0.0361446 11.4857L4.39157 0.428572C4.4759 0.142857 4.68675 0 5.0241 0H6.99398C7.30723 0 7.51807 0.142857 7.62651 0.428572L11.9819 11.4857C11.994 11.52 12 11.5714 12 11.64C12 11.7429 11.9639 11.8286 11.8916 11.8971C11.8193 11.9657 11.7349 12 11.6386 12H10.0663C9.90964 12 9.78916 11.9657 9.70482 11.8971C9.62048 11.8286 9.56627 11.7543 9.54217 11.6743L8.69277 9.58286H3.3253L2.4759 11.6743C2.37952 11.8914 2.20482 12 1.95181 12H0.379518ZM8.06024 7.61143L6 2.31429L3.95783 7.61143H8.06024Z"
                                        fill="#B8D7F5"/>
                            </svg>
                        </p>
                    </div>
                </div>
                <div class="t-inputBox t-inputBox_column t-inputBox_column-start" v-else>
                    <div class="t-profile__contactsInput" v-for="(contact, index) in form_contacts">
                        <div class="t-input t-input_320" :class="{_error: contact.error, '_success': (contact.value != '')}">
                            <label>{{ contact.title }}</label>
                            <input v-model="contact.value" @input="InputContact(contact)" @focus="FocusContact(contact)">
                        </div>
                        <button class="t-input__delete" @click.stop.prevent="DelContact(index)">
                            <svg width="15" height="18" viewBox="0 0 15 18" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                      d="M8.99831 1C8.99831 0.447266 8.55105 0 7.99831 0C7.62136 0 7.29324 0.207031 7.12331 0.513672C7.04324 0.658203 6.99831 0.824219 6.99831 1V2H2.99831C2.44558 2 1.99831 2.44727 1.99831 3C1.99831 3.55273 2.44558 4 2.99831 4H7.99831H12.9983C13.551 4 13.9983 3.55273 13.9983 3C13.9983 2.44727 13.551 2 12.9983 2H8.99831V1ZM1.99831 5C1.70144 5 1.42019 5.13086 1.23074 5.35938C1.04128 5.58594 0.961205 5.88672 1.01394 6.17969L1.74245 10.1797L2.46902 14.1797L3.01394 17.1797C3.10183 17.6543 3.51589 18 3.99831 18H11.9983C12.4807 18 12.8948 17.6543 12.9827 17.1797L14.2542 10.1797L14.9827 6.17969C15.012 6.01367 15.0003 5.8457 14.9495 5.68945C14.9104 5.57031 14.8479 5.45703 14.7659 5.35938C14.5764 5.13086 14.2952 5 13.9983 5H1.99831ZM3.56081 9L3.19558 7H12.801L12.4358 9H3.56081ZM4.28738 13L3.9241 11H12.0725L11.7093 13H4.28738ZM4.8323 16L4.65066 15H11.346L11.1643 16H4.8323Z"
                                      fill="#52A8F2"/>
                            </svg>
                        </button>
                        <div class="t-profile__contactsCheckbox">
                            <div>
                                <svg width="12" height="14" viewBox="0 0 12 14" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M2 2V11.22L3.74603 9.55893C4.34081 8.9931 5.12899 8.63474 6 8.63474C6.871 8.63474 7.65919 8.9931 8.25397 9.55893L10 11.22V2H2ZM9.9662 12.2101C9.96605 12.21 9.96707 12.2079 9.96972 12.2042C9.96767 12.2083 9.96635 12.2102 9.9662 12.2101ZM2.0338 12.2101C2.03365 12.2102 2.03232 12.2083 2.03028 12.2042C2.03293 12.2079 2.03395 12.21 2.0338 12.2101ZM10.5 0C11.3284 0 12 0.888889 12 1.98539V12.0111C12 13.6286 10.6169 14.5673 9.62455 13.6233L6.87545 11.008C6.35237 10.5103 5.64763 10.5103 5.12455 11.008L2.37545 13.6233C1.3831 14.5673 0 13.6286 0 12.0111V1.98539C0 0.888889 0.671573 0 1.5 0H10.5Z"
                                          fill="#B8D7F5"/>
                                </svg>
                                <input type="checkbox" :id="'newContactMain_' + index" class="t-checkbox"
                                       v-model="contact.main" @change="SetMainContact(index)">
                                <label :for="'newContactMain_' + index">
                                    {{ pageTextInfo.main }}
                                </label>
                            </div>
                            <div>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                            d="M0.379518 12C0.283133 12 0.192771 11.9657 0.108434 11.8971C0.0361446 11.8286 0 11.7429 0 11.64L0.0361446 11.4857L4.39157 0.428572C4.4759 0.142857 4.68675 0 5.0241 0H6.99398C7.30723 0 7.51807 0.142857 7.62651 0.428572L11.9819 11.4857C11.994 11.52 12 11.5714 12 11.64C12 11.7429 11.9639 11.8286 11.8916 11.8971C11.8193 11.9657 11.7349 12 11.6386 12H10.0663C9.90964 12 9.78916 11.9657 9.70482 11.8971C9.62048 11.8286 9.56627 11.7543 9.54217 11.6743L8.69277 9.58286H3.3253L2.4759 11.6743C2.37952 11.8914 2.20482 12 1.95181 12H0.379518ZM8.06024 7.61143L6 2.31429L3.95783 7.61143H8.06024Z"
                                            fill="#B8D7F5"/>
                                </svg>
                                <input type="checkbox" :id="'newContactAdmin_' + index" class="t-checkbox"
                                       v-model="contact.admin">
                                <label :for="'newContactAdmin_' + index">
                                    {{ pageTextInfo.admin }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="t-input t-input_320">
                        <label>{{ pageTextInfo.newContacts }}</label>
                        <v-select :placeholder="pageTextInfo.addContacts"
                                  :options="contactsType"
                                  :searchable="false"
                                  :filterable="false"
                                  @input="AddContacts($event)"></v-select>
                    </div>
                </div>
                <div class="t-input_buttons">
                    <button class="t-btn" v-if="!editContacts" @click.stop.prevent="editContacts = true"><span>{{ pageTextInfo.updateBtn }}</span>
                    </button>
                    <template v-else>
                        <button class="t-btn"
                                :disabled="user.isTeacher && !canSaveContacts"
                                @click.stop.prevent="SaveContacts"><span>{{ pageTextInfo.saveBtn }}</span>
                        </button>
                        <button class="t-btn t-btn_white" @click.stop.prevent="CancelContacts"><span>{{ pageTextInfo.cancelBtn }}</span>
                        </button>
                    </template>
                </div>
            </div>

            <cmp-documents :pageText="pageTextInfo" :isProfile="true"></cmp-documents>
        </div>
    </div>
</template>

<script>

    import {store} from '../../store'

    import DatePicker from 'vue2-datepicker'
    import TopicsSelect from '../../vue_components/TopicsSelect.vue'
    import MultiSelect from '../../vue_components/MultiSelect.vue'
    import Documents from '../../vue_components/Documents.vue'

    import {mapActions, mapGetters} from 'vuex';
import user from '../../store/modules/user';


    import EdirMyInfo from '../../vue_mixins/EditMyInfo';

    export default {

        mixins: [EdirMyInfo],
        components: {
            DatePicker,
            'cmp-documents': Documents
        },
        data() {
            return {
                // pageText: {},

                editInfo: true,
                editVideo: false,
                editContacts: false,

                form_video: {
                    type: '',
                    name: 'video',
                    title: '',
                    value: '',
                    link: '',
                    placeholder: '',
                    error: false,
                    error_text: '',
                    pattern: '',
                    required: false
                },
            }
        },
        computed: {
            ...mapGetters('profile', ['documents']),
            fullName() {
                if (this.user) {
                    if (this.user.name === null && this.user.patronymic === null && this.user.last_name === null)
                        return '';
                    else
                        return this.user.name + ' ' + this.user.patronymic + ' ' + this.user.last_name;
                }
                else {
                    return '';
                }
            },
            birth_day() {
                if (this.user) {
                    if (this.user.birth_day === null)
                        return '';

                    let date = new Date(this.user.birth_day);
                    let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
                    let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);

                    return day + '.' + month + '.' + date.getFullYear();
                }
            },
            language() {
                if (this.user) {
                    let value = '';
                    if (this.user.language) {
                        for (let i = 0; i < this.user.language.length; i++) {
                            value += this.user.language[i].label;
                            if ((i + 1) < this.user.language.length)
                                value += ', ';
                        }
                    }
                    return value !== '' ? value : this.pageTextInfo.empty;
                }
            },
            field_knowledge() {
                if (this.user) {
                    let value = '';
                    if (this.user.field_knowledge) {
                        for (let i = 0; i < this.user.field_knowledge.length; i++) {
                            value += this.user.field_knowledge[i].label;

                            if ((i + 1) < this.user.field_knowledge.length)
                                value += ', ';
                        }
                    }
                    return value !== '' ? value : this.pageText.empty;
                }
            },
            interesting_topics() {
                if (this.user) {
                    let value = '';
                    if (this.user.topics) {
                        for (let i = 0; i < this.user.topics.length; i++) {
                            value += this.user.topics[i].label;

                            if ((i + 1) < this.user.topics.length)
                                value += ', ';
                        }
                    }
                    return value !== '' ? value : this.pageTextInfo.empty;
                }
            },
            time_zone() {
                if (this.user.time_zone) {
                    return this.user.time_zone.label
                } else {
                    return ''
                }
            },
            about() {
                let div = document.createElement("div");
                div.innerHTML = this.user.about;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            education() {
                let div = document.createElement("div");
                div.innerHTML = this.user.education;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            },
            experience() {
                let div = document.createElement("div");
                div.innerHTML = this.user.experience;
                let text = div.textContent || div.innerText || "";
                let replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
                let replacedText = text.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
                let replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
                replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
                let replacePattern3 = /(\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,6})/gim;
                replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1">$1</a>');

                return replacedText;
            }
        },
        methods: {
            ...mapActions(['UpdatePreloadState']),
            ...mapActions('profile', ['updateAvatar', 'LoadUserInfo', 'updateVideo', 'updateContacts']),
            ...mapActions('msg', ['showMsg']),
            load(){
                this.form_video.title = this.pageTextInfo.formVideoTitle;
                this.form_video.placeholder = this.pageTextInfo.formVideoPlaceholder;
                this.form_video.error_text = this.pageTextInfo.formVideoError;

                this.form_video.value = this.user.video;

                if (this.form_video.value !== null) {
                    if (this.form_video.value.indexOf('youtube') >= 0 || this.form_video.value.indexOf('youtu.be') >= 0) {
                        this.form_video.type = 'youtube';
                        this.form_video.link = this.form_video.value.split('?v=')[1];
                        
                        if (!this.form_video.link){
                            this.form_video.link = this.form_video.value.split('youtu.be/')[1];
                        }

                        this.form_video.link = this.form_video.link.split('&')[0];
                    }
                    if (this.form_video.value.indexOf('vimeo') >= 0) {
                        this.form_video.type = 'vimeo';
                        let index = this.form_video.value.lastIndexOf('/') + 1;
                        this.form_video.link = this.form_video.value.substring(index, this.form_video.value.length);
                    }
                }
            },

            CancelInfo() {
                this.editInfo = false;

                for (let i = 0; i < this.form_info.length; i++) {
                    if (!this.user[this.form_info[i].name]){
                        this.form_info[i].value = '';
                    } else if (typeof this.user[this.form_info[i].name] === 'object') {
                        if ( Array.isArray(this.user[this.form_info[i].name] ) ) {
                            this.form_info[i].value = Object.assign([], this.user[this.form_info[i].name]);
                        } else {
                            this.form_info[i].value = Object.assign({}, this.user[this.form_info[i].name]);
                        }
                    } else {
                        this.form_info[i].value = this.user[this.form_info[i].name];
                    }
                }
            },
            SaveVideo() {
                let fd = new FormData();
                fd.append('video', this.form_video.value);

                this.$http.put('update_video', fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            this.updateVideo(this.form_video.value);
                            this.editVideo = false;

                            if (this.form_video.value.indexOf('youtube') >= 0 || this.form_video.value.indexOf('youtu.be') >= 0) {
                                this.form_video.type = 'youtube';
                                this.form_video.link = this.form_video.value.split('?v=')[1];

                                if (!this.form_video.link){
                                    this.form_video.link = this.form_video.value.split('youtu.be/')[1];
                                }
                                this.form_video.link = this.form_video.link.split('&')[0];
                            }
                            if (this.form_video.value.indexOf('vimeo') >= 0) {
                                this.form_video.type = 'vimeo';
                                let index = this.form_video.value.lastIndexOf('/') + 1;
                                this.form_video.link = this.form_video.value.substring(index, this.form_video.value.length);
                            }
                            this.editVideo = false;
                            this.showMsg(this.pageTextInfo.msgInfoUpdate)
                        } else {
                            this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                        }
                    })
                    .catch(error => {
                        this.showMsg('Упс, что-то пошло не так, попробуйте позже')
                    });
            },
            CancelVideo() {
                this.editVideo = false;
                this.form_video.value = this.user.video;
            },

        },
        beforeRouteLeave(to, from, next) {
            // this.UpdatePreloadState(true);
            next();
        },
        beforeRouteEnter(to, from, next) {

            let count = 0;

            store.dispatch('staticText/LoadDocumentsText').then(() => {
                count++;
                RunNext();
            });
            // store.dispatch('handbook/LoadLanguages', {popular: true, offset: 0, limit: 15}).then(() => {
            //     count++;
            //     RunNext();
            // });
            // store.dispatch('handbook/LoadFieldKnowledgee').then(() => {
            //     count++;
            //     RunNext();
            // });
            // store.dispatch('handbook/LoadInterestingTopics').then(() => {
            //     count++;
            //     RunNext();
            // });
            store.dispatch('handbook/LoadTopics').then(() => {
                count++;
                RunNext();
            });
            // store.dispatch('handbook/LoadContactsType').then(() => {
            //     count++;
            //     RunNext();
            // });
            store.dispatch('handbook/LoadTimeZone').then(() => {
                count++;
                RunNext();
            });
            // store.dispatch('profile/LoadUserInfo').then(() => {
            //     count++;
            //     RunNext();
            // });

            store.dispatch('profile/LoadDocuments', {page: 1}).then(() => {
                count++;
                RunNext();
            });

            let RunNext = () => {
                if (count > 3){
                    next(vm => vm.load())
                }
            }
        }
    }
</script>

<style lang="sass">

    .t-avatar
        display: flex
        flex-direction: column
        margin-bottom: 32px
        &__img
            width: 256px
            height: 256px
            object-fit: cover
            margin-bottom: 24px
            border-radius: 8px
            overflow: hidden
            &._h-auto
                height: auto
            &-edit
                width: calc(256px + 24px)
                height: calc(256px + 24px)
                margin: -12px -12px 12px
        &__info
            font-size: 14px
            line-height: normal
            color: $black
            margin-bottom: 16px
        &_wrapper
            display: flex
            flex-direction: column
            width: 256px
        // .t-btn
        //     margin-top: 10px
        .t-btn_file
            margin-bottom: 8px
        


    .t-page_profile
        .t-profile, .t-page_profile
            h2
                color: $blue
                margin: 0 0 16px
            &__video
                margin: 0 0 24px
                border-radius: 16px
                overflow: hidden
                width: 272px
                height: 152px
                iframe
                    width: 100%
                    height: 100%
            .t-input__styled
                a
                    color: #52a8f2
                p 
                    word-break: break-word
            .t-input_320:last-child
                margin-top: 16px
        .t-avatar
            margin-bottom: 0

    .t-profile
        &__description
            margin-bottom: 24px
        &__contacts
            display: flex
            align-items: center
            svg
                margin-left: 10px
        &__contactsInput
            width: 100%
            display: flex
            align-items: flex-start
            .t-input_320
                width: 320px
                padding-right: 0
                margin-right: 9px
            .t-input__delete
                position: relative
                margin-right: 14px
                outline: none
                margin-top: 27px
            @media(max-width: 769px)
                flex-wrap: wrap
                .t-input_320
                    width: calc(100% - 40px - 9px)
                    margin-bottom: 0
                .t-input__delete
                    margin: 26px 0 0
            &._must
                order: -1 
                // color: red
                // .t-input_320
                //     width: 100%

        &__contactsCheckbox
            margin-top: 20px
            svg
                margin-right: 10px
            @media(max-width: 769px)
                margin-top: 8px
                margin-bottom: 16px


</style>



// WEBPACK FOOTER //
// src/vue_pages/Profile/MyInfo.vue